import moment from 'moment/moment';

export const FACEBOOK_CALLBACK = process.env.REACT_APP_FACEBOOK_CALLBACK;
export const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID;
export const GOOGLE_CAPTCHA = process.env.REACT_APP_GOOGLE_CAPTCHA;
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
export const APP_ENV = process.env.REACT_APP_ENV || 'local';

export const ANALYTICS_ENDPOINT =
  process.env.REACT_APP_ANALYTICS_ENDPOINT || '';
export const DOMAIN_SITE = `.${process.env.REACT_APP_DOMAIN || ''}`;
export const APP_ENDPOINT = `${process.env.REACT_APP_ENDPOINT || ''}`;
export const DOMAIN_SITE_URL = `${process.env.REACT_APP_SITE_URL || ''}`;
export const COOKIES_OPTIONS = {
  expires: moment().add(1, 'year').toDate(),
  path: '/',
  domain: DOMAIN_SITE,
};

export const ANALYTICS_COOKIES_OPTIONS = {
  expires: moment().add(1, 'day').toDate(),
  path: '/',
  domain: DOMAIN_SITE,
};

export const USER_COOKIE = 'grupoanimal_session';
export enum PaymentSelection {
  OpenPay = 'OPENPAY',
  PayPal = 'PAYPAL',
  Stripe = 'STRIPE_CARD',
}

export const GUEST_ROLE = 'GUEST';

export const MAILCHIMP_API_KEY = process.env.REACT_APP_MAILCHIMP_API_KEY || '';
export const MAILCHIMP_SERVER_PREFIX =
  process.env.REACT_APP_MAILCHIMP_SERVER_PREFIX || '';
export const MAILCHIMP_AUDIENCE =
  process.env.REACT_APP_MAILCHIMP_AUDIENCE || '';

/**
 * Stripe envs-
 */
export const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY || '';
export const STRIPE_SECRET_KEY = process.env.REACT_APP_STRIPE_SECRET_KEY || '';

/**
 * PAYPAL envs
 */
export const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID || '';
export const PostsPlansPage = [
  {
    title: 'La Estafa Maestra: Graduados en desaparecer dinero público',
    img: '/estafa-maestra.png',
    url: 'https://animalpolitico.com/estafa-maestra',
  },
  {
    title: 'Votar entre balas',
    img: '/votar-entre.png',
    url: 'https://panel.animalpolitico.com/elecciones-2024-violencia-votar-entre-balas/',
  },
  {
    title: 'No fuimos Dinamarca el saldo de la austeridad de AMLO',
    img: '/no-fuimos.png',
    url: 'https://panel.animalpolitico.com/amlo-austeridad-en-salud-no-fuimos-dinamarca/',
  },
  {
    title:
      'Miedo, castigo y estigma: el fracaso de la política de drogas de AMLO',
    img: '/miedo-estigma.png',
    url: 'https://panel.animalpolitico.com/politica-drogas-amlo-fracaso/',
  },
  {
    title:
      'México destruyendo el futuro: jóvenes atrapados entre la violencia y el abandono',
    img: '/mexico-destruyendo.png',
    url: 'https://panel.animalpolitico.com/mexico-destruyendo-el-futuro/',
  },
];

export const TIPS_PRICE_ID = process.env.REACT_APP_TIPS_PRICE_ID || '';
